/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Contacttitle1Inputs */

const id_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi Kami`)
};

const ms_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi Kami`)
};

const da_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Os`)
};

const de_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktieren Sie uns`)
};

const en_us2_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Us`)
};

const es_es2_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos`)
};

const es_mx2_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos`)
};

const fil_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makipag-ugnayan sa Amin`)
};

const fr_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous contacter`)
};

const it_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contattaci`)
};

const hu_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapcsolat`)
};

const nl_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neem contact op`)
};

const no_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt oss`)
};

const pl_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const pt_br2_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contate-nos`)
};

const pt_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacte-nos`)
};

const ro_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactați-ne`)
};

const fi_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ota yhteyttä`)
};

const sv_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakta oss`)
};

const vi_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ với chúng tôi`)
};

const tr_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bizimle İletişime Geçin`)
};

const cs_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktujte nás`)
};

const bg_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свържете се с нас`)
};

const ru_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свяжитесь с нами`)
};

const uk_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зв'яжіться з нами`)
};

const ar_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اتصل بنا`)
};

const hi_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमसे संपर्क करें`)
};

const th_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อเรา`)
};

const ja_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const zh_cn2_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们`)
};

const zh_hant1_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`聯絡我們`)
};

const ko_privacy_contacttitle1 = /** @type {(inputs: Privacy_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의하기`)
};

/**
* | output |
* | --- |
* | "Contact Us" |
*
* @param {Privacy_Contacttitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_contacttitle1 = /** @type {((inputs?: Privacy_Contacttitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Contacttitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_contacttitle1(inputs)
	if (locale === "ms") return ms_privacy_contacttitle1(inputs)
	if (locale === "da") return da_privacy_contacttitle1(inputs)
	if (locale === "de") return de_privacy_contacttitle1(inputs)
	if (locale === "en-US") return en_us2_privacy_contacttitle1(inputs)
	if (locale === "es-ES") return es_es2_privacy_contacttitle1(inputs)
	if (locale === "es-MX") return es_mx2_privacy_contacttitle1(inputs)
	if (locale === "fil") return fil_privacy_contacttitle1(inputs)
	if (locale === "fr") return fr_privacy_contacttitle1(inputs)
	if (locale === "it") return it_privacy_contacttitle1(inputs)
	if (locale === "hu") return hu_privacy_contacttitle1(inputs)
	if (locale === "nl") return nl_privacy_contacttitle1(inputs)
	if (locale === "no") return no_privacy_contacttitle1(inputs)
	if (locale === "pl") return pl_privacy_contacttitle1(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_contacttitle1(inputs)
	if (locale === "pt") return pt_privacy_contacttitle1(inputs)
	if (locale === "ro") return ro_privacy_contacttitle1(inputs)
	if (locale === "fi") return fi_privacy_contacttitle1(inputs)
	if (locale === "sv") return sv_privacy_contacttitle1(inputs)
	if (locale === "vi") return vi_privacy_contacttitle1(inputs)
	if (locale === "tr") return tr_privacy_contacttitle1(inputs)
	if (locale === "cs") return cs_privacy_contacttitle1(inputs)
	if (locale === "bg") return bg_privacy_contacttitle1(inputs)
	if (locale === "ru") return ru_privacy_contacttitle1(inputs)
	if (locale === "uk") return uk_privacy_contacttitle1(inputs)
	if (locale === "ar") return ar_privacy_contacttitle1(inputs)
	if (locale === "hi") return hi_privacy_contacttitle1(inputs)
	if (locale === "th") return th_privacy_contacttitle1(inputs)
	if (locale === "ja") return ja_privacy_contacttitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_contacttitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_contacttitle1(inputs)
	return ko_privacy_contacttitle1(inputs)
});
export { privacy_contacttitle1 as "privacy.contactTitle" }